import { AppUserModel } from "@/core/models/app-user.model";
import { AppRoleRepo } from "@/core/repos/tables/app-role.repo";
import { AppUserRepo } from "@/core/repos/tables/app-user.repo";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import container from "@/lib/di/container";
import { Modal, Button, ConfigProvider, message, Form, Input } from "antd";
import { Dispatch, SetStateAction, useState, useEffect } from "react";

const appUserRepo = container.get(AppUserRepo);
const appRoleRepo = container.get(AppRoleRepo);

interface ChangePasswordModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: AppUserModel
}

const INPUT_WIDTH = 450;

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({isModalOpen, setIsModalOpen, data}) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [form] = Form.useForm<AppUserModel>();
    const handleDataChange = async () => {
        form.setFieldsValue(data);
    }
    useEffect(()=>{
        handleDataChange();
    }, [data])

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const handleSave = async () => {
        setLoading(true);
        const result = await appUserRepo.changePassword(data.userName, form.getFieldValue("passwordHash"));
        setIsModalOpen(false);
        form.setFieldsValue(data);
        if (result) {
            message.success({
                content: "Đã cập nhật"
            })
        } else {
            message.error({
                content: "Cập nhật thất bại"
            })
        }
        setLoading(false);
    };

    const validatePasswords = (_: any, value: string): Promise<void> => {
        if (value && value !== form.getFieldValue('passwordHash')) {
          return Promise.reject(new Error('Mật khẩu không giống nhau!'));
        }
        return Promise.resolve();
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            <Modal open={isModalOpen} onCancel={handleCancel} width={510} centered
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[
                    <div key={1} className="w-full flex flex-row justify-end px-1.5">
                        <Button key="submit" type="primary" loading={loading}
                            style={{ 
                                background: "var(--primary-color)", 
                                paddingRight: 48, 
                                paddingLeft: 48, 
                                fontSize: 18,
                                fontWeight: 600,
                                paddingTop: 18, 
                                paddingBottom: 18,
                                }}
                            onClick={handleSave}
                        >
                            LƯU
                        </Button>
                    </div>,
                ]}
            >
                <div className="flex flex-row w-full items-start justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">CHI TIẾT BẢN GHI</p>
                </div>
                <div className="flex flex-row justify-center mt-6">
                    <Form<AppUserModel>
                        name="basic"
                        className="flex flex-col items-start"
                        autoComplete="off"
                        labelAlign="left"
                        layout="vertical"
                        form={form}
                    >
                         <Form.Item<AppUserModel>
                            label="Tài khoản"
                            name="userName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Vui lòng tên tài khoản!',
                                },
                            ]}
                        >
                            <Input placeholder="Nhập tài khoản" style={{width: INPUT_WIDTH}} disabled></Input>
                        </Form.Item>
                        <Form.Item<AppUserModel>
                            name="passwordHash"
                            label="Mật khẩu"
                            rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập mật khẩu!',
                            },
                            ]}
                        >
                            <Input.Password style={{width: INPUT_WIDTH}} placeholder="Nhập mật khẩu" />
                        </Form.Item>
                        <Form.Item
                            name="confirm"
                            label="Xác nhận mật khẩu"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                            {
                                required: true,
                                message: 'Vui lòng xác nhận mật khẩu!',
                            },
                            {
                                validator: validatePasswords,
                            },
                            ]}
                        >
                            <Input.Password style={{width: INPUT_WIDTH}} placeholder="Xác nhận mật khẩu" />
                        </Form.Item>
                    </Form>
                </div>
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
        </ConfigProvider>
    )
} 